import React from 'react'
import PropTypes from 'prop-types'

import Spinner from '../misc/spinner'
import { Button } from 'lensrentals-components'

import styles from '../../assets/stylesheets/pages/cart/cart_loader.module.scss'

const CartLoader = props => {
  if (props.loading) {
    return (
      <div className={styles.loading}>
        <Spinner size={0.5} padding={0} loading={true} />
      </div>
    )
  } else if (props.error.message)  {

    const { message, button } = props.error
    return (
      <p className={styles.error}>
        <span className={styles.error__message}>{message}</span>
        <br />
        {button !== 'default'
          ? button
          : <Button 
            className={styles.button}
            color="highlight"
            onClick={() => location.reload()}
            type='button'
          >
            Reload this page?
          </Button>
        }
      </p>
    )
  } else {
    return props.children
  }
}

CartLoader.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
    button: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ])
  }),
  children: PropTypes.node.isRequired
}

export default CartLoader
